module.exports = __webpack_public_path__ + "img/1020_2.ae5878db.jpg";